import { AppState } from '../initialStateRegistration';

export const getSecondaryHeader = (state:AppState) => state.secondaryHeader;

export const getLogos = (state:AppState) => getSecondaryHeader(state).logo;

export const getLinks = (state:AppState) => getSecondaryHeader(state).links;

export const getMoreLinksText = (state:AppState) => getSecondaryHeader(state).moreLinksText;
